import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/addproperty.css';
import '../../css/addroomdetails.css';
import '../../css/styles.css';
import chennaipincode from '../../assets/pincode.json';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import axios from "axios";
import Dashboard from './Dashboard';


const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});


const LocationSelector = ({ setPosition, setAddress }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);

      // Fetch address using reverse geocoding
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        );
        const data = await response.json();
        if (data.display_name) {
          setAddress(data.display_name);
        } else {
          setAddress("Address not found");
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    }
  });

  return null;
};

const steps = [
  { id: 1, label: "Property Details" },
  { id: 2, label: "Address" },
  { id: 3, label: "Photos" },
  { id: 4, label: "Verify" },
  { id: 5, label: "Review" },
];

export const AddPropertyCommercialResale = ({ agent_id, agent_name}) => {

  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const pincodeData = chennaipincode;
  const [step, setStep] = useState(1);
  const [propertyType, setPropertyType] = useState("Commercial");
  const [lookingTo, setLookingTo] = useState("Resale");
  const [building, setBuilding] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedPincode, setSelectedPincode] = useState('');
  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState('');
  const [locality, setLocality] = useState("");
  const [possessionStatus, setPossessionStatus] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const [availableFrom, setAvailableFrom] = useState("");
  const [builtuparea, setBuiltuparea] = useState(""); 
  const [carpetarea, setCarpetarea] = useState("");
  const [entrancewidth, setEntranceWidth] = useState("");
  const [cellingheight, setCellingheight] = useState("");
  const [Ownership, setOwnership] = useState("");
  const [price, setPrice] = useState("");
  const [Negotiable, setNegotiable] = useState("");
  const [localityError, setLocalityError] = useState(false);
  const [located, setLocated] = useState('');
  const [Ageofproperty, setAgeofproperty] = useState("");
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [currentrentpermonth, setCurrentRentMonth] = useState("");
  const [leaseyears, setLeaseYears] = useState("");
  const [expectedreturn, setExpectedreturn] = useState("");
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [TaxGovt, setTaxGovt] = useState([]);
  const [leasedrented, setLeasedrented] = useState([]);
  const [totalFloors, setTotalFloors] = useState("");
  const [privateParking, setPrivateParking] = useState(false);
  const [publicParking, setPublicParking] = useState(false);
  const [privateWashrooms, setPrivateWashrooms] = useState("");
  const [publicWashrooms, setPublicWashrooms] = useState("");
  const [yourFloor, setYourFloor] = useState("");
  const [Address, setAddress] = useState("");
  const [position, setPosition] = useState([12.9716, 77.5946]); // Default Lat/Lng for Velachery
  const [paraaddress, setParaAddress] = useState("");
 const [errors, setErrors] = useState({});

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };


  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    setImages([...images, ...files]);
  };

  const handleVideoUpload = (event) => {
    const files = Array.from(event.target.files);
    setVideos([...videos, ...files]);
  };

  const zoneTypes = [
    "Jewellery",
    "GYM",
    "Grocery",
    "Clinic",
    "Footwear",
    "Electronics",
    "Clothing",
    "Others"
  ];

  const locationHubs = [
    "Mall",
    "Commercial Project",
    "Residential Project",
    "Retail Complex/Building",
    "Market/High Street",
    "Others",
  ];

  const categories = [
    { name: "Office", icon: "📄" },
    { name: "Retail Shop", icon: "🏪" },
    { name: "Showroom", icon: "🏢" },
    { name: "Warehouse", icon: "🏠" },
    { name: "Plot", icon: "📐" },
    { name: "Others", icon: "🙂" },
  ];

  
    useEffect(() => {
      const fetchCoordinates = async () => {
        if (!locality.trim()) return;
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${locality}, Chennai`
          );
          const data = await response.json();
          if (data.length > 0) {
            const lat = parseFloat(data[0].lat);
            const lon = parseFloat(data[0].lon);
            setPosition([lat, lon]);
            setAddress(data[0].display_name);
          } else {
            setAddress("Location not found");
          }
        } catch (error) {
          console.error("Error fetching coordinates:", error);
        }
      };
  
      if (locality) {
        fetchCoordinates();
      }
    }, [locality]);
  
  
    const [selectedCategories, setSelectedCategories] = useState([]);

  const toggleCategory = (categoryName) => {
    setSelectedCategories((prevSelected) =>
      prevSelected.includes(categoryName)
        ? prevSelected.filter((name) => name !== categoryName) // Remove if already selected
        : [...prevSelected, categoryName] // Add if not selected
    );
  };
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  const toggleSelection = (value, selectedList, setSelectedList, errorKey) => {
    setSelectedList((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value) // Remove if already selected
        : [...prevSelected, value]
    );
    setErrors({ ...errors, [errorKey]: "" });
  };

  const wrapperRef = useRef(null);
  const navigate = useNavigate();


  const amenities = [
    "CCTV",
    "Power Backup",
    "Internet Connectivity",
    "Water Storage",
    "DG Availabilty",
    "Cafeteria",
    "Security Personnel",
    "Vastu Compliant",


  ];

  const handleLookingToClick = (option) => {
    setLookingTo(option);

    // Redirect based on selection
    if (propertyType === "Residential" && option === "Rent") {
      navigate("/residential-rent");
    } else if (propertyType === "Residential" && option === "Resale") {
      navigate("/residential-resell");
    } else if (propertyType === "Residential" && option === "PG/Co-living") {
      navigate("/");
    } else if (propertyType === "Commercial" && option === "Rent") {
      navigate("/Commercial-rent");
    } else if (propertyType === "Commercial" && option === "Resale") {
      navigate("/Commercial-resale");
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filter pincode suggestions based on the search term
  const filteredPincodes = pincodeData.filter(item =>
    item.pincode.includes(searchTerm)
  );

  // Handle changes in the pincode input field
  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowSuggestions(true);
    if (!e.target.value) setShowSuggestions(false);
  };

  // Handle selecting a pincode from suggestions
  const handleSelect = (pincode) => {
    setSelectedPincode(pincode);
    const selected = pincodeData.find(item => item.pincode === pincode);
    setLocalities(selected ? selected.locality : []);
    setShowSuggestions(false);
  };

  // Handle selecting a locality
  const handleLocalityChange = (event) => {
    setSelectedLocality(event.target.value);
    setErrors({ ...errors, selectedLocality: "" });
  };

  const validateForm = () => {
    let newErrors = {};
  
    // Step 1: Property Details Validation
    if (currentStep === 1) {
      if (!propertyType) newErrors.propertyType = "Please select a property type.";
      if (!lookingTo) newErrors.lookingTo = "Please select your purpose.";
      if (!locality) newErrors.locality = "Please enter your city.";
      if (!selectedPincode) newErrors.pincode = "Please enter the pincode.";
      if (!selectedLocality) newErrors.selectedLocality = "Please select a locality.";
      if (selectedCategories.length === 0) newErrors.selectedCategories = "Please select at least one property type.";
    }
  
    // Step 2: Property Details Validation
    if (currentStep === 2) {
      if (!building) newErrors.building = "Please enter the building name.";
      if (!propertyName) newErrors.propertyName = "Please enter the property name.";
      if (!possessionStatus) newErrors.possessionStatus = "Please select the possession status.";
      if (!availableFrom) newErrors.availableFrom = "Please select the available from date.";
      if (possessionStatus === "Ready to move" && !Ageofproperty) newErrors.Ageofproperty = "Please enter the age of the property.";
      if (selectedZones.length === 0) newErrors.selectedZones = "Please select at least one suitable zone.";
      if (selectedLocations.length === 0) newErrors.selectedLocations = "Please select at least one location hub.";
      if (!builtuparea) newErrors.builtuparea = "Please enter the built-up area.";
      if (!carpetarea) newErrors.carpetarea = "Please enter the carpet area.";
      if (!entrancewidth) newErrors.entrancewidth = "Please enter the entrance width.";
      if (!cellingheight) newErrors.cellingheight = "Please enter the ceiling height.";
      if (!located) newErrors.located = "Please select the location.";
      if (!Ownership) newErrors.Ownership = "Please select the ownership type.";
      if (!price) newErrors.price = "Please enter the price.";
      if (!Negotiable) newErrors.Negotiable = "Please select if the price is negotiable.";
      if (!TaxGovt) newErrors.TaxGovt = "Please select if tax and government charges are included.";
      if (!totalFloors) newErrors.totalFloors = "Please enter the total floors.";
      if (!yourFloor) newErrors.yourFloor = "Please select your floor.";
      if (!privateWashrooms) newErrors.privateWashrooms = "Please enter the number of private washrooms.";
      if (!publicWashrooms) newErrors.publicWashrooms = "Please enter the number of public washrooms.";
      if (!leasedrented) newErrors.leasedrented = "Please select if it is pre-leased/pre-rented.";
      if (leasedrented === "yes" && !currentrentpermonth) newErrors.currentrentpermonth = "Please enter the current rent per month.";
      if (leasedrented === "yes" && !leaseyears) newErrors.leaseyears = "Please enter the lease years.";
      if (leasedrented === "No" && !expectedreturn) newErrors.expectedreturn = "Please enter the expected return on investment.";
    }
  
    // Step 3: Amenities Validation
    if (currentStep === 3) {
      if (selectedAmenities.length === 0) newErrors.selectedAmenities = "Please select at least one amenity.";
    }
  
    // Step 4: Address Validation
    if (currentStep === 4) {
      if (!selectedLocality.trim()) newErrors.selectedLocality = "Locality is required.";
      if (!Address.trim()) newErrors.Address = "Address is required.";
    }
  
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleNextStep = () => {
    if (validateForm()) {
      if (currentStep < steps.length) {
        setCurrentStep((prev) => prev + 1);
      }
    }
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("proptype", propertyType);
    formData.append("lookingto", lookingTo);
    formData.append("bpn", building);
    formData.append("city", "Chennai");
    formData.append("pincode", selectedPincode);
    formData.append("pinlocality", selectedLocality);
    formData.append("propertyname", selectedCategories.join(", "));
    formData.append("pname", propertyName);
    formData.append("possessionstatus", possessionStatus);
    formData.append("availablefrom", availableFrom);
    formData.append("ageofproperty", Ageofproperty);
    formData.append("zonetype", selectedZones.join(", "));
    formData.append("locationhub", selectedLocations.join(", "));
    formData.append("builtuparea", builtuparea);
    formData.append("carpetarea", carpetarea);
    formData.append("entrancewidth", entrancewidth);
    formData.append("cellingheight", cellingheight);
    formData.append("located", located);
    formData.append("ownership", Ownership);
    formData.append("price", price);
    formData.append("taxgovt", TaxGovt);
    formData.append("negotiable", Negotiable);
    formData.append("totalfloors", totalFloors);
    formData.append("yourfloor", yourFloor);
    formData.append("privateparking", privateParking);
    formData.append("publicparking", publicParking);
    formData.append("privatewashrooms", privateWashrooms);
    formData.append("publicwashrooms", publicWashrooms);
    formData.append("leasedrented", leasedrented);
    formData.append("currentrentpermonth", currentrentpermonth);
    formData.append("leaseyears", leaseyears);
    formData.append("expectedreturn", expectedreturn);
    formData.append("amenities", selectedAmenities.join(", "));
    formData.append("address", Address);
    formData.append("agent_name", agent_name);
    formData.append("agent_id", agent_id);
    formData.append("fdt", new Date().toISOString());
    formData.append("status", "active");

    images.forEach((image, index) => {
      formData.append(`images`, image);
    });

    videos.forEach((video, index) => {
      formData.append(`video`, video);
    });

    try {
      const response = await axios.post("/add-property", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response.data);
      alert("Property added successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form", error.message);
    }
  };

  return (
    <div><Dashboard/>
    <div className="postprop" >

    {/* Sidebar */}
    <div className="sidebar">
   <h2>Post your property</h2>
   <p>Welcome! {agent_name} || {agent_id}</p>
   <p>ReSell or rent your property</p>

   <div className="timeline">
     {steps.map((step) => (
       <div key={step.id} className={`step ${step.id < currentStep ? "complete" : step.id === currentStep ? "active" : ""}`}>
         <div className="circle">{step.id < currentStep ? "✓" : step.id}</div>
         <div className="label">
           <p>{step.label}</p>
           <span>{step.id < currentStep ? "Completed" : step.id === currentStep ? "In progress" : "Pending"}</span>
         </div>
       </div>
     ))}
   
   </div>
   <span>need help: call +91 9585973683</span>
 </div>

 {/* Add PG/Co-living Properties */}
 <div className="form-section">
 <div className="form-container ">
 

 {currentStep === 1 && (
     <div className='container2'>
          <h2 className="text-xl font-semibold mb-4"><u>Add Property Details</u></h2>

          {/* Property Type */}
          <div className="mb-4">
            <p className="mb-2 font-medium">Property Type *</p>
            <div className="button-group">
              <button
                className={`button ${propertyType === "Residential" ? "selected" : ""}`}
                onClick={() => setPropertyType("Residential")}
              >
                Residential
              </button>
              <button
                className={`button ${propertyType === "Commercial" ? "selected" : ""}`}
                onClick={() => setPropertyType("Commercial")}
              >
                Commercial
              </button>
            </div>
          </div>

          {/* Looking To */}
          <div className="mb-4">
            <p className="mb-2 font-medium">Looking to *</p>
            <div className="button-group">
              {(propertyType === "Residential"
                ? ["Rent", "Resale", "PG/Co-living"]
                : ["Rent", "Resale"]
              ).map((option) => (
                <button
                  key={option}
                  className={`btnsmall ${lookingTo === option ? "btnsmall-selected" : ""
                    }`}
                  onClick={() => handleLookingToClick(option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>


          {/* Locality */}
          <div className="mb-4">
          <label className="block mb-2 font-medium">Entre City *</label>
            <input
              type="text"
              value={locality}
              onChange={(e) => {
                setLocality(e.target.value);
              setErrors({ ...errors, locality: "" });
            }}
              className="w-full border p-2 rounded-lg"
              placeholder="Enter City"
              required
            />
             {errors.locality && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.locality}
        </span>)}
          </div>

          {/* Enter Pincode */}
          <div className="mb-4">
            <label className='block mb-2 font-medium' htmlFor="pincode">Enter Pincode:</label>
            <input
              type="number"
              id="pincode"
              className="w-full border p-2 rounded-lg"
              value={selectedPincode || searchTerm}
              onChange={handleInputChange}
              placeholder="Type pincode"
              autoComplete="off"
              required
              inputMode="numeric"
              maxLength={6}

            />
             {errors.pincode && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.pincode}
                  </span>
                )}
          </div>

          {/* Suggestions dropdown for pincode */}
          {showSuggestions && (
            <div className="suggestions-dropdown shadow-sm mb-4">
              {filteredPincodes.length > 0 ? (
                filteredPincodes.map((item) => (
                  <div
                    key={item.pincode}
                    className="suggestion-item"
                    onClick={() => {
                      handleSelect(item.pincode);
                      setErrors({ ...errors, pincode: "" });
                    }}
                  >
                    <div className="pincode">{item.pincode}</div>
                    <div className="area">{item.area}</div>
                  </div>
                ))
              ) : (
                <div className="no-results">No pincodes found</div>
              )}
            </div>
          )}

          {/* After selecting pincode, show locality dropdown */}
          {selectedPincode && (
            <>
              <div className="mb-4">
                <label className='block mb-2 font-medium' htmlFor="locality">Select Locality:</label>
                <select
                  id="locality"
                  value={selectedLocality}
                  onChange={handleLocalityChange}
                  className="w-full border p-2 rounded-lg"
                >
                  <option value="">Select a locality</option>
                  {localities.map((locality, index) => (
                    <option key={index} value={locality}>
                      {locality}
                    </option>
                  ))}
                </select>
              </div>
              {errors.selectedLocality && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.selectedLocality}
                  </span>
                )}
            </>
          )}

          <h3>Property Type <span className="required">*</span></h3>
          <div className="grid">
            {categories.map((category) => (
              <button
                key={category.name}
                className={`grid-item ${selectedCategories.includes(category.name) ? "active" : ""}`}
                onClick={() => {
                  toggleCategory(category.name);
                  setErrors({ ...errors, selectedCategories: "" });
                }}
                required
              >
                <span className="icon">{category.icon}</span>
                {category.name}
              </button>
            ))}
            {errors.selectedCategories && (
                  <span style={{ color: 'red',fontSize: '0.8rem' }} 
                  className="text-sm">{errors.selectedCategories}
                  </span>
                )}
          </div>

          {/* Next Button */}
          {/* <button onClick={() => setStep(2)} className="next-button">Next, add property details</button> */}
        </div>
      )}



{currentStep === 2 && (
          <div>
          <h2>Add Property Details</h2>

          {/* Building / Society */}
          <label>Building/Project/Society (Optional)</label>
          <input 
          type="text" 
          value={building} 
          onChange={(e) => {
            setBuilding(e.target.value);
            setErrors({ ...errors, building: "" });
          }}
             required
             placeholder="Enter building name" 
             />
             {errors.building && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.building}
        </span>)}


          {/* Property Name */}
          <label>Property Name <span className="required">*</span></label>
          <input
            type="text"
            value={propertyName}
            onChange={(e) => {
              setPropertyName(e.target.value);
            setErrors({ ...errors, propertyName: "" }); 
          }}
            placeholder="Enter property name"
            required
          />
            {errors.propertyName && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.propertyName}
        </span>)}


          {/* Possession Info */}
          <h3>POSSESSION INFO</h3>
          <label>Possession status <span className="required">*</span></label>
          <div className="button-group">
            {["Ready to move", "Under construction"].map((status) => (
              <button
                key={status}
                className={possessionStatus === status ? "active" : ""}
                onClick={() => {
                  setPossessionStatus(status);
                setErrors({ ...errors, possessionStatus: "" });
              }}
              required
              >
                {status}
              </button>
            ))}
            {errors.possessionStatus && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.possessionStatus}
        </span>)}
          </div>

          {/* Available From */}
          <label>Available From <span className="required">*</span></label>
          <input
            type="date"
            value={availableFrom}
            onChange={(e) => {
              setAvailableFrom(e.target.value);
            setErrors({ ...errors, availableFrom: "" });
          }}
          required
          />
             {errors.availableFrom && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.availableFrom}
        </span>)}

          
{/* Age of Property */}
          {possessionStatus === "Ready to move" && (
            <div>
              <label>Age of Property(in Years) <span className="required">*</span></label>
              <input
                type="number"
                value={Ageofproperty}
                onChange={(e) => {
                  setAgeofproperty(e.target.value);
                setErrors({ ...errors, Ageofproperty: "" });
              }}
              required
              />
               {errors.Ageofproperty && (
        <span style={{ color: 'red',fontSize: '0.8rem' }}
        className="text-sm">{errors.Ageofproperty}
        </span>)}
            </div>
          )}
          <hr />

          <h2>ABOUT THE PROPERTY</h2>

          {/* Zone Type */}
          <label>
            Suitable For <span className="required">*</span>
          </label>
          <div className="button-group">
            {zoneTypes.map((zone) => (
              <button
                key={zone}
                className={selectedZones.includes(zone) ? "active" : ""}
                onClick={() => toggleSelection(zone, selectedZones, setSelectedZones, "selectedZones")}
              >
                {zone}
              </button>
            ))}
          </div>
          {errors.selectedZones && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.selectedZones}
          </span>
        )}

          {/* Location Hub */}
          <label>
            Location Hub <span className="required">*</span>
          </label>
          <div className="button-group">
            {locationHubs.map((location) => (
              <button
                key={location}
                className={selectedLocations.includes(location) ? "active" : ""}
                onClick={() => toggleSelection(location, selectedLocations, setSelectedLocations, "selectedLocations")}
              >
                {location}
              </button>
            ))}
          </div>
          {errors.selectedLocations && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.selectedLocations}
          </span>
        )}

       {/* Built-up Area */}
       <label>Built Up Area <span className="required">*</span></label>
          <div className="input-group">
            <input 
            type="number" 
            placeholder="Enter area" 
            value={builtuparea} 
            onChange={(e) => {
              setBuiltuparea(e.target.value);
              setErrors({ ...errors, builtuparea: "" });
            }}
            required
              />
            <span className="unit">sq. ft.</span>
          </div>
          {errors.builtuparea && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.builtuparea}
          </span>
        )}

          {/* Carpet Area */}
          <label>Carpet Area <span className="required">*</span></label>
          <div className="input-group">
            <input 
            type="number" 
            placeholder="Enter area" 
            value={carpetarea} 
            onChange={(e) => {
              setCarpetarea(e.target.value);
            setErrors({ ...errors, carpetarea: "" });  
            }}
            required
              />
            <span className="unit">sq. ft.</span>
          </div>
          {errors.carpetarea && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.carpetarea}
          </span>
        )}


          {/* Entrance width in feet */}
          <label>Entrance width in feet <span className="required">*</span></label>
          <div className="input-group">
            <input 
            type="number" 
            placeholder="Enter Entrance width" 
            value={entrancewidth} 
            onChange={(e) => {
              setEntranceWidth(e.target.value);
              setErrors({ ...errors, entrancewidth: "" });
              }}
              required
              />
            <span className="unit">ft.</span>
          </div>
          {errors.entrancewidth && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.entrancewidth}
          </span>
        )}


          {/* Ceilling height in feet */}
          <label>Ceilling height in feet <span className="required">*</span></label>
          <div className="input-group">
            <input 
            type="number" 
            placeholder="Enter Ceilling height" 
            value={cellingheight} 
            onChange={(e) => {
              setCellingheight(e.target.value);
              setErrors({ ...errors, cellingheight: "" });
              }}
              required
              />
            <span className="unit">sq. ft.</span>
          </div>
          {errors.cellingheight && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.cellingheight}
          </span>
        )}


          {/* Located Near */}
          <label>Located Near <span className="required">*</span></label>
          <div className="button-group">
            {["Entrance", "Elevator", "stairs"].map((status) => (
              <button
                key={status}
                className={located === status ? "active" : ""}
                onClick={() => {
                  setLocated(status);
                setErrors({ ...errors, located: "" });
                }}
                required
              >
                {status}
              </button>
            ))}
          </div>
          {errors.located && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.located}
          </span>
        )}


          {/* Ownership */}
          <label>Ownership <span className="required">*</span></label>
          <div className="button-group">
            {["Freehold", "Leasehold", "Cooperative society", "Power of attorney"].map((status) => (
              <button
                key={status}
                className={Ownership === status ? "active" : ""}
                onClick={() => {
                  setOwnership(status);
                setErrors({ ...errors, Ownership: "" });
                }}
                required
              >
                {status}
              </button>
            ))}
          </div>
          {errors.Ownership && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.Ownership}
          </span>
        )}


          {/* Price */}
          <label>Price<span className="required">*</span></label>
          <div className="input-group">
            <input 
            type="number" 
            placeholder="Enter price" 
            value={price} 
            onChange={(e) => {
              setPrice(e.target.value);
              setErrors({ ...errors, price: "" });
              }} />
          </div>
          {errors.price && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.price}
          </span>
        )}


          {/* Negotiable */}
          <label>Negotiable  <span className="required">*</span></label>
          <div className="button-group">
            {["yes", "No"].map((status) => (
              <button
                key={status}
                className={Negotiable === status ? "active" : ""}
                onClick={() => {
                  setNegotiable(status);
                setErrors({ ...errors, Negotiable: "" });
              }}
              required
              >
                {status}
              </button>
            ))}
          </div>
          {errors.Negotiable && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.Negotiable}
          </span>
        )}

          {/* Tax & Govt. charge included */}

          <label>TaxGovt <span className="required">*</span></label>
          <div className="button-group">
            {["yes", "No"].map((status) => (
              <button
                key={status}
                className={TaxGovt === status ? "active" : ""}
                onClick={() => {
                  setTaxGovt(status);
                setErrors({ ...errors, TaxGovt: "" });
                }}
              >
                required
                {status}
              </button>
            ))}
          </div>
          {errors.TaxGovt && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.TaxGovt}
          </span>
        )}
          <hr />


          <h3>Floors Available</h3>
          <label>Total Floors *</label>
          <input
            type="number"
            value={totalFloors}
            onChange={(e) => {
              setTotalFloors(e.target.value);
              setErrors({ ...errors, totalFloors: "" });
            }}
            required
            placeholder="Enter total floors"
          />
           {errors.totalFloors && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.totalFloors}
          </span>
        )}


        {/* Your Floor */}
        <div>
          <div className='container3'>
            <label>Your Floor *</label>
            <select 
            value={yourFloor} 
            onChange={(e) => {
              setYourFloor(e.target.value);
            setErrors({ ...errors, yourFloor: "" });  
            }}
            required
              >
              <option value="">Select</option>
              {[...Array(Number(totalFloors) || 10)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
               {errors.yourFloor && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.yourFloor}
          </span>
        )}
        </div>


        {/* Parking */}
            <div className="checkbox-group">
              <h3>Parking</h3>
              <label>
                <input
                  type="checkbox"
                  checked={privateParking}
                  onChange={() => setPrivateParking(!privateParking)}
                />
                Private Parking
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={publicParking}
                  onChange={() => setPublicParking(!publicParking)}
                />
                Public Parking
              </label>
            </div>
          </div>

          {/* Facilities */}
          {/* Private Washrooms */}

          <h3>Facilities</h3>
          <label>Private Washrooms *</label>
          <input
            type="number"
            value={privateWashrooms}
            onChange={(e) => {
              setPrivateWashrooms(e.target.value);
              setErrors({ ...errors, privateWashrooms: "" });
            }}
            required
            placeholder="Enter number"
          />
          {errors.privateWashrooms && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.privateWashrooms}
          </span>
        )}


          <label>Public Washrooms *</label>
          <input
            type="number"
            value={publicWashrooms}
            onChange={(e) => {
              setPublicWashrooms(e.target.value)
              setErrors({ ...errors, publicWashrooms: "" });
            }}
            required
            placeholder="Enter number"
          />
          {errors.publicWashrooms && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.publicWashrooms}
          </span>
        )}
        <hr />

        
          <label>Is it pre-leased/pre-rented <span className="required">*</span></label>
          <div className="button-group">
            {["yes", "No"].map((status) => (
              <button
                key={status}
                className={leasedrented === status ? "active" : ""}
                onClick={() => {
                  setLeasedrented(status);
                setErrors({ ...errors, leasedrented: "" });
              }}
              required
              >
                {status}
              </button>
            ))}
             {errors.leasedrented && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.leasedrented}
          </span>
        )}
          </div>

          {leasedrented === "yes" && (
            <>
              <label>Current rent per month*</label>
              <input
                type="text"
                placeholder=""
                value={currentrentpermonth}
                onChange={(e) => {
                  setCurrentRentMonth(e.target.value);
                  setErrors({ ...errors, currentrentpermonth: "" });
                }}
                required
              />
               {errors.currentrentpermonth && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.currentrentpermonth}
          </span>
        )}


              <label>Lease years *</label>
              <input
                type="text"
                value={leaseyears} 
                onChange={(e) => {
                  setLeaseYears(e.target.value);
                  setErrors({ ...errors, leaseyears: "" });
                }}
                required
                placeholder=""
              />
               {errors.leaseyears && (
          <span style={{ color: 'red', fontSize: '0.8rem' }} 
          className="text-sm">{errors.leaseyears}
          </span>
        )}
            </>
          )}
          {leasedrented === "No" && (
            <>
              <label>Expected Return on Investment* %per annum</label>
              <input
                type="text"
                value={expectedreturn} onChange={(e) => setExpectedreturn(e.target.value)}
                placeholder=""
              />

            </>
          )}


          {/* <button onClick={() => setStep(1)} className="next-button">Back</button>
          <button onClick={() => setStep(3)} className="next-button">Next, add amenities</button> */}
        </div>
      )}


    {currentStep === 3 && (

          <div>
          {/* Amenities */}
          <label>
            Amenities <span className="required">*</span>
          </label>
          <div className="button-group">
            {amenities.map((item) => (
              <button
                key={item}
                className={selectedAmenities.includes(item) ? "active" : ""}
                onClick={() => {
                  toggleSelection(item, selectedAmenities, setSelectedAmenities);
                  setErrors({ ...errors, selectedAmenities: "" });
                }}
              >
                {item}
              </button>
            ))}
            {errors.selectedAmenities && (
             <span 
             style={{ color: 'red', fontSize: '0.8rem' }} 
             className="text-sm">{errors.selectedAmenities}
             </span>
            )}
          </div>

          {/* Image Upload Section */}
          <div className="mb-4">
            <label className="block mb-2 font-medium">Upload Images</label>
            <input type="file" accept="image/*" multiple onChange={handleImageUpload} className="w-full p-2 border rounded-lg" />
            <div className="grid grid-cols-3 gap-2 mt-2">
              {images.map((image, index) => (
                <img key={index} src={URL.createObjectURL(image)} alt="Uploaded" className="w-full h-20 object-cover rounded-lg" />
              ))}
            </div>
          </div>

          {/* Video Upload Section */}
          <div className="mb-4">
            <label className="block mb-2 font-medium">Upload Videos</label>
            <input type="file" accept="video/*" multiple onChange={handleVideoUpload} className="w-full p-2 border rounded-lg" />
            <div className="grid grid-cols-2 gap-2 mt-2">
              {videos.map((video, index) => (
                <video key={index} controls className="w-full h-32 rounded-lg">
                  <source src={URL.createObjectURL(video)} type="video/mp4" />
                </video>
              ))}
            </div>
          </div>

          <button onClick={() => setStep(2)} className="next-button">
            Back
          </button>

          {/* Save Button */}
          {/* <button onClick={() => setStep(4)} className="next-button">
            address
          </button> */}
        </div>
      )}

{currentStep === 4 && (
  
          <div >
          <h2 className="text-lg font-semibold">Add Address</h2>
          <p className="text-gray-600">Locality / Sector *</p>
          <input
            type="text"
            className="w-full border rounded-lg p-2 my-2"
            value={selectedLocality}
            onChange={(e) => setLocality(e.target.value)}
            placeholder="Enter location of the property.."
          />

          <h3 className="text-md font-medium mt-4">Where is your property located?</h3>
          <p className="text-sm text-gray-500">
            Search for a location or click on the map to select manually.
          </p>

          <div className="mapcontainer">
            <MapContainer center={position} zoom={14} style={{ height: "400px", width: "100%", alignItems: "center" }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <Marker position={position} icon={customIcon}>
                <Popup>{paraaddress || "Click on the map to select location"}</Popup>
              </Marker>
              <LocationSelector setPosition={setPosition} setAddress={setAddress} />
            </MapContainer>
          </div>

          <p className="mt-2 text-gray-700 md-6">
            <strong>Selected Address:</strong> {Address}
          </p>
{/* 
          <button className="next-button" onClick={handleSubmit}>
            Post Property
          </button>

          <button className='next-button' onClick={() => setStep(3)}>Back</button> */}
        </div>
      )}
      <div className="button-group">
            {currentStep > 1 && (
              <button onClick={handlePrevStep} className="button prev">
                Back
              </button>
            )}
            {currentStep < steps.length ? (
              <button onClick={handleNextStep} className="button next">
                Next
              </button>
            ) : (
              <button className="button submit">Submit</button>
            )}
          </div>
          </div>
          </div>



          </div>
    </div>
  )
}
